
<script setup>

  import { ArrowLeftCircleIcon } from '@heroicons/vue/24/outline';

  import { letterBackground } from '../stores/activity-3.js';

  import backgroundPaths from '../images/activity-3-part-2-background-*.png';

  import backgroundPath from '../images/distressed-background.jpg';

  const backgrounds = [ {

    id: 'table',
    
    title: 'Picnic Table'
  
  }, {
    
    id: 'typewriter',
    
    title: 'Typewriter'

  }, {

    id: 'nightstand',
    
    title: 'Nightstand'

  } ].map( obj => ( { ...obj, path: backgroundPaths[ obj.id ] } ) );

</script>

<template>

  <article>
    
    <div class="flex items-center justify-center min-h-view px-6 py-12 bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="w-full max-w-3xl lg:max-w-4xl">

        <div class="text-md font-bold uppercase">Step 2</div>

        <h3 class="max-w-2xl text-4xl font-heading uppercase pb-6 border-b-2 border-black">

          Choose a Background for Your Letter

        </h3>

        <div class="flex flex-col md:flex-row gap-12 mt-12">

          <RouterLink v-for="{ id, title, path } in backgrounds" class="group" to="/activity/3/part/2/step/3" @click="letterBackground = id">

            <img class="h-64 md:h-48 lg:h-64 aspect-square mx-auto duration-300 transition-[opacity,transform]
            
              group-hover:opacity-40 group-focus-visible:opacity-40 group-hover:translate-y-1 group-focus-visible:translate-y-1"
            
              :src="path" alt="" aria-hidden="true" draggable="false" />

            <div class="mt-4 text-center font-semibold text-xl duration-300 transition-transform
            
              group-hover:translate-y-3 group-focus-visible:translate-y-3">
              
              {{ title }}
            
            </div>

          </RouterLink>

        </div>

        <div class="mt-12">

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 font-bold bg-amber-300 transition-colors pointer-events-auto
            
              hover:bg-amber-400 focus-visible:bg-amber-400 hover:underline focus-visible:underline"
          
            to="/activity/3/part/2/step/1">

            <ArrowLeftCircleIcon class="w-8" />

            <span>Back</span>

          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
